import Slider from '../slider/index';

export default (element, data) => {
  const init = () => {

    const sliderSelector = element.querySelector('[data-slider]');
    const sliderWrapper = sliderSelector.querySelector('.swiper-wrapper');

    if (!sliderSelector) return;

    const nextButton = element.querySelector('.button-next ');
    const prevButton = element.querySelector('.button-prev');

    // eslint-disable-next-line no-shadow
    const initSlider = (data) => {
      if (data?.exploreTheCollection?.length) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden');
        return;
      }
      if (data.exploreTheCollection.length === 2) {
        sliderSelector.classList.add('md:w-[704px]')
      }
      const slides = data.exploreTheCollection.map((variant) => {
        const variantDescription = variant.description.split('.')[0];
        return `
          <div class="swiper-slide !h-auto">
            <div class="w-full h-full flex flex-col 
                       ${data.exploreTheCollection.length < 2 && 'md:max-w-[347px] md:mx-auto'} ">
              <a href=${variant.url} 
              class="block absolute inset-0 z-10 no-underline
              aria-label="${variant.title}"
              ">
              </a>
              <div class="relative aspect-[283/283] md:aspect-[447/447]">
                <img src="${variant.image}" alt="${variant.alt}" 
                  loading="lazy"
                  class="object-cover object-center h-full absolute inset-0"/>
              </div>
            <div 
            class="text-center max-w-[293px] 
            mt-3.5 lg:mt-4 mx-auto flex flex-col justify-end grow">
              <p class='h4'>${variant.title}</p>
              <div class="paragraph-4 mt-4 grow" data-paragraph>
                ${variantDescription}
              </div>
              <div class="mt-4 pb-0.5">
                <a href="${variant.url}" class="cta--underline">
                  ${window.TMW.Strings.product.shopButton}
                </a>
              </div>
            </div>
            </div>
          </div>`
      });

      sliderWrapper.innerHTML = '';
      slides.forEach(slide => {
        sliderWrapper.insertAdjacentHTML('beforeend', slide)
      });

      const slider = new Slider({
        el: sliderSelector,
        options: {
          autoHeight: false,
          slidesPerView: 1.31,
          spaceBetween: 10,
          centeredSlides: true,
          initialSlide: 1,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            745: {
              centeredSlides: true,
              slidesPerView: slides.length > 3 ? 3 : slides.length,
              centeredSlidesBounds: true,
              spaceBetween: 10,
              noSwiping: slides.length < 3,
              noSwipingClass: 'swiper-slide'
            }
          }
        }
      });
      // eslint-disable-next-line consistent-return
      return slider;
    }

    let sliderInited = initSlider(data.product.variants[0]);

    const buttonsPosition = () => {
      const slideImg = sliderSelector.querySelector('img');
      if (!slideImg) return;
      nextButton.style.top = `${(slideImg.offsetHeight - 16) / 2}px`;
      prevButton.style.top = `${(slideImg.offsetHeight - 16) / 2}px`;
    }


    window.addEventListener('resize', () => {
      buttonsPosition();
    });

    window.addEventListener('load', () => {
      buttonsPosition();
    });

    document.addEventListener("currentVariantUpdated", (event) => {
      const exploreData = event.detail.currentProductData.variants
        .find(variant => variant.id === event.detail.currentVariant);

      sliderInited?.destroy();
      sliderInited = initSlider(exploreData);
      buttonsPosition();
    });

  };

  init();
};
